module controllers {
    export module master {

        interface ICustomsPartyListCtrlScope extends ng.IScope {


        }

        interface ICustomsPartyListParams extends ng.ui.IStateParamsService {
        }

        export class customsPartyListCtrl {
            static $inject = ["$scope",
                "$rootScope",
                "generalService",
                "$q",
                "bsLoadingOverlayService",
                "entityService",
                "$timeout",
                '$uibModal',
                'customsPartyService',
                '$state',
                '$stateParams',
                '$transitions',
                'statusService',
                'classificationValueService',
                'countryService'
            ];

            IsLoading: boolean = false;
            ShowGrid: boolean = false;

            gridApi: uiGrid.IGridApi;
            allDirtyRows: Array<interfaces.master.ICustomsPartyDisplay>;
            searchAccordian: boolean = false;
            myHook: any;

            customsPartySearch: interfaces.master.ICustomsPartySearch = {
                CompanyStatusId:0
            };

            paginationOptions = {
                pageNumber: 1,
                pageSize: 25
            };

            ctrlName: string;

            sortName: string;
            sortDirection: string;


            dropdownsObject = {
                CustomsPartyStatusList: Array<interfaces.applicationcore.IDropdownModel>(),
            };

            statusList: interfaces.applicationcore.IDropdownModel[] = [];

            apiList: uiGrid.IGridApi;
            selected: uiGrid.IGridRow;

            items: string[];
            entity: string;
            currentEntity: interfaces.applicationcore.IEntity;

            selectedRowsArray: Array<interfaces.master.ICustomsPartyDisplay> = [];

            filterNames: string[] = ["EntityCode",
                "CustomsCode",
                "CompanyCode",
                "CompanyName",
                "CountryCode",
                "CompanyStatus",
                "ManageCreditLimit",
                "CreditLimit",
                "CurrentBalanceAndCreditLimit",
                "PercentageBalanceRemaining",
                "CustomsCurrencyCode"
        ];

            filterList: interfaces.applicationcore.IKeyValue[] = [];



            constructor(private $scope: ICustomsPartyListCtrlScope,
                private $rootScope: interfaces.applicationcore.IRootScope,
                public generalService: interfaces.applicationcore.IGeneralService,
                private $q: ng.IQService, private bsLoadingOverlayService,
                private entityService: interfaces.applicationcore.IEntityService,
                private $timeout: ng.ITimeoutService,
                private $uibModal: ng.ui.bootstrap.IModalService,
                private customsPartyService: interfaces.master.ICustomsPartyService,
                private $state: ng.ui.IStateService,
                private $stateParams: ICustomsPartyListParams,
                private $transitions: ng.ui.core.ITransition,
                private statusService: interfaces.master.IStatusService,
                private classificationValueService: interfaces.applicationcore.IClassificationValueService,
                private countryService: interfaces.applicationcore.ICountryService
            ) {

                this.customsPartySearch = {
                    IsActive: true, CompanyStatusId: 0
                };

                this.ctrlName = 'CustomsParty List Controller';

                this.loadControls();

                this.myHook = $transitions.onSuccess({
                    to: 'auth.MasterData.CustomsParty',
                    from: 'auth.MasterData.CustomsParty.**'
                }, () => {
                    this.loadCustomsPartys();
                });

                $scope.$on('$destroy', () => {
                    $transitions.onStart({}, this.myHook)
                });
            }

            loadCustomsPartys() {

                this.bsLoadingOverlayService.wrap({
                    referenceId: 'customsParty'
                },
                    () => {
                        var searchObject: interfaces.applicationcore.ISearchObject = {
                            filters: [],
                            sorts: []
                        }
 
                        if(!this.customsPartySearch.CompanyStatusId)
                        {
                            this.customsPartySearch.CompanyStatusId=0;
                        }
                    
                        angular.forEach(this.customsPartySearch, (n, key) => {
                            if (n["Id"]) {
                                searchObject.filters.push({ Name: key, Value: n.Id });
                            } else {
                                searchObject.filters.push({ Name: key, Value: n });
                            }
                        });

                        if (this.gridApi) {
                            var grid = this.gridApi.grid;
                            angular.forEach(grid.columns, (n: uiGrid.IGridColumn) => {
                                if (n.filters[0].term) {
                                    searchObject.filters.push({ Name: n.name, Value: n.filters[0].term });
                                }

                                if (n.sort.direction) {
                                    searchObject.sorts.push({
                                        Name: n.name,
                                        SortDirection: n.sort.direction === "asc" ? 0 : 1,
                                        SortOrder: n.sort.priority
                                    });
                                }
                            });
                        }

                        var params = {
                            connectSearch: searchObject,
                            numberRecords: this.paginationOptions.pageSize,
                            pageNumber: this.paginationOptions.pageNumber,
                        }

                        return this.customsPartyService.getList().query(params, (data) => {
                            this.IsLoading = false;
                            this.gvwList.data = data;
                            this.selectedRowsArray = [];

                            if (data[0]) {
                                this.gvwList.totalItems = data[0].NumberRecords;
                            } else {
                                this.gvwList.totalItems = 0;
                            }
                            this.$timeout(() => {
                                if (this.apiList) {
                                    this.getFilters();
                                    this.setFilters();
                                }
                            });

                        }
                            , (errorResponse) => {
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                            }).$promise;
                    });

            }


            loadControls() {
                let controlPromises = [
                    this.loadStatuses()
                ]

                this.$q.all(controlPromises).then((data) => {

                    this.ShowGrid = true;
                    this.DoSearch();
                });

            }


            search_click() {
                this.ShowGrid = true;
                this.IsLoading = true;
                this.searchAccordian = false;
                this.DoSearch();
            }

            showAll_click() {
                this.ShowGrid = true;
                this.IsLoading = true;
                this.searchAccordian = false;
                this.customsPartySearch = {}
                this.filterList = [];

                if (this.apiList !== undefined) {
                    this.apiList.grid.clearAllFilters(true, true, true).then(() => {
                        this.apiList.grid.resetColumnSorting(null);
                        this.DoSearch();
                    });
                } else {
                    this.DoSearch();
                }
            }

            DoSearch() {
                this.IsLoading = true;

                var searchObject: interfaces.applicationcore.ISearchObject = {
                    filters: [],
                    sorts: []
                }

                angular.forEach(this.customsPartySearch, (n, key) => {

                    if (n) {
                        if (n["Id"]) {

                            searchObject.filters.push({ Name: key, Value: n.Id });

                        } else {
                            searchObject.filters.push({ Name: key, Value: n });
                        }
                    }
                });

                if (this.apiList) {
                    var grid = this.apiList.grid;

                    angular.forEach(grid.columns, (n: uiGrid.IGridColumn) => {
                        if (n.filters[0].term) {
                            searchObject.filters.push({ Name: n.name, Value: n.filters[0].term });
                        }

                        if (n.sort.direction) {
                            searchObject.sorts.push({
                                Name: n.name,
                                SortDirection: n.sort.direction === "asc" ? 0 : 1,
                                SortOrder: n.sort.priority
                            });
                        }

                    });

                   
                }

                if (this.currentEntity)
                    this.entity = this.currentEntity.Code;

                var params = {
                    connectSearch: searchObject,
                    numberRecords: this.paginationOptions.pageSize,
                    items: this.items,
                    entityCode: this.entity,
                    pageNumber: this.paginationOptions.pageNumber
                }
                
                this.customsPartyService.getList().query(params, (data) => {
                    this.IsLoading = false;
                    this.gvwList.data = data;
                    this.selectedRowsArray = [];

                    if (data[0]) {
                        this.gvwList.totalItems = data[0].NumRecs;
                    } else {
                        this.gvwList.totalItems = 0;
                    }


                    this.$timeout(() => {
                        if (this.apiList) {
                            this.getFilters();
                            this.setFilters();
                        }
                    });

                    this.$timeout(() => {
                        if (this.selected) {
                            var index = _.findIndex(this.gvwList.data, (o) => { return o.Id === this.selected.entity.Id });
                            this.apiList.selection.selectRow(this.gvwList.data[index]);
                        }
                    });
                 


                }, (data) => {
                    this.IsLoading = false;
                    this.gvwList.data = [];
                    this.gvwList.totalItems = 0;
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>data.data);
                });
            }

            downloadToExcel() {
                this.IsLoading = true;

                var searchObject: interfaces.applicationcore.ISearchObject = {
                    filters: [],
                    sorts: []
                }
                angular.forEach(this.customsPartySearch, (n, key) => {

                    if (n["Id"]) {
                        searchObject.filters.push({ Name: key, Value: n.Id });
                    } else {
                        searchObject.filters.push({ Name: key, Value: n });
                    }
                });

                if (this.apiList) {

                    var grid = this.apiList.grid;

                    angular.forEach(grid.columns, (n: uiGrid.IGridColumn) => {
                        if (n.filters[0].term) {
                            searchObject.filters.push({ Name: n.name, Value: n.filters[0].term });
                        }

                        if (n.sort.direction) {
                            searchObject.sorts.push({
                                Name: n.name,
                                SortDirection: n.sort.direction === "asc" ? 0 : 1,
                                SortOrder: n.sort.priority
                            });
                        }
                    });
                }

                var params = {
                    connectSearch: searchObject,
                    items: this.items,
                    entityCode: this.entity,
                }

                this.customsPartyService.getCustomsPartiesExcel(params).then(() => {
                    this.IsLoading = false;
                }, (data) => {
                    this.IsLoading = false;
                    this.gvwList.data = [];
                    this.gvwList.totalItems = 0;
                    this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>data.data);
                });
            }

            

            testClick(){
                console.log('button clicked!')
            }


            uploadCreditLimitsFromExcel() {
                
                this.$uibModal.open({
                    animation: true,
                    size: "lg",
                    template: `
                        <div class="modal-header" style="white-space: nowrap;">
                            <h3 class="modal-title" id="modal-title">Upload Credit Limits</h3>
                        </div>
                        <div bs-loading-overlay bs-loading-overlay-reference-id="cominv.excelupload">
                            <form name="cominvexcelupload">
                                <div class="gts-padding">
                                    <gts-message-display messages="Messages"></gts-message-display>
                                    <div class="modal-body" id="modal-body">
                                       
                                      <div class="row" style="border-width:2px;border-style:solid;margin-top:20px;font-size:15px;padding:25px;border-radius:25px;">
        

                                        <div class="row">
                                            <div class="col-md-10">
                                                <p>
                                                The Excel Credit Limit Upload file can be used to do a bulk upload of all customs duty and VAT credit limits for Customs Parties.
                                                The Credit Limit and, if applicable Balance, is assumed to be in the customs currency of country of the customs party. You can
                                                use the Download option to download the current balances in GTS in the same format as the upload.
                                                </p>
                                            </div>
                                            <div class="col-md-2">                                         
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-10">
                                             <p>
                                                - If you choose the override balance option, this will override the current GTS calculated balance with the new figure provided.<br>
                                                - If you choose the Ignore Invalid Customs Parties option, GTS will not throw an error for a Customs Party that does not exist in GTS.
                                             </p>
                                            </div>
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-small btn-primary action-button" ng-click="$event.preventDefault(); $event.stopPropagation(); uploadCreditLimitExcelCtrl.downloadCreditLimitsToExcel();">
                                                        Download 
                                                </button>
                                            </div>
                                        </div>
                                      </div>
                                        <hr>
                                        <div class="row vertical-align">
                                            <div class="col-md-2">
                                                <req></req>
                                                <label>Entity</label>
                                            </div>
                                            <div class="col-md-6">
                                                <p class="input-group-sm">
                                                    <select class="form-control" ng-model="uploadCreditLimitExcelCtrl.ownerEntityId" ng-change="uploadCreditLimitExcelCtrl.ownerEntityChanged()">
                                                        <option ng-repeat="entity in uploadCreditLimitExcelCtrl.entityList" ng-value="entity.Id">
                                                            {{entity.Code}} - {{entity.Name}}
                                                        </option>
                                                    </select>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="row vertical-align">
                                            
                                            <div class="col-md-2">                                                
                                            </div>
                                            <div class="col-md-6">
                                                <p class="input-group-sm">
                                                    <input type="checkbox" ng-model="uploadCreditLimitExcelCtrl.ignoreInvalidCustomsParties"  />
                                                    <label>Ignore Invalid CustomsParties</label>
                                                </p>
                                                
                                            </div>
                                        </div>

                                        <div class="row vertical-align">
                                            <div class="col-md-2">                                  
                                            </div>
                                            <div class="col-md-6">
                                                    <p class="input-group-sm">
                                                    <input type="checkbox" ng-model="uploadCreditLimitExcelCtrl.overrideBalance"  />
                                                    <label>Override Balance</label>
                                                </p>
                                            </div>
                          
                                        </div>

                                        
                                            <div class="row vertical-align">
                                                <div class="col-md-2">                                  
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="fileUpload btn btn-primary file-upload-btn-primary" for="docFileToUpload" ng-disabled="uploadCreditLimitExcelCtrl.disableSubmit">
                                                        <span>Select File</span>
                                                        <input name="docFileToUpload" ng-disabled="uploadCreditLimitExcelCtrl.disableSubmit" class="upload" type="file" id="docFileToUpload" ng-model="uploadCreditLimitExcelCtrl.repositoryFile" base-sixty-four-input accept=".xlsx" />
                                                    </label>
                                                    <span>{{uploadCreditLimitExcelCtrl.repositoryFile.filename}}</span>
                                                </div>
                                            </div>
                                          
                                    </div>
                                    <div class="modal-footer"> 
                                        <button class="btn btn-primary" type="button"  ng-disabled="!uploadCreditLimitExcelCtrl.repositoryFile || uploadCreditLimitExcelCtrl.disableSubmit" ng-click="uploadCreditLimitExcelCtrl.upload()">Upload</button>
                                        <button class="btn btn-info" type="button" ng-disabled="uploadCreditLimitExcelCtrl.disableSubmit" ng-click="uploadCreditLimitExcelCtrl.cancel()">Cancel</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        `,
                    controller: class uploadCreditLimitExcelCtrl {

                        disableSubmit: boolean = false;
                        messages: interfaces.applicationcore.IMessage[];

                        entityList: ng.resource.IResourceArray<interfaces.applicationcore.IEntity>;
                        ownerEntityId: number;

                        ignoreInvalidCustomsParties: boolean = false;
                        overrideBalance: boolean = false;
                      
                        repositoryFile: interfaces.applicationcore.IRepositoryFile;
                        fileTemplate: interfaces.applicationcore.IDropdownModel;

                        fileTemplateList: interfaces.applicationcore.IDropdownModel[] = [];

                        viewFileTemplateRight: boolean = false;

                        productsExcelData: interfaces.master.IProductExcelData;

                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
                            private countryService: interfaces.applicationcore.ICountryService,
                            private entityService: interfaces.applicationcore.IEntityService,
                            private customsPartyService: interfaces.master.ICustomsPartyService,
                            public generalService: interfaces.applicationcore.IGeneralService,
                            private $rootScope: interfaces.applicationcore.IRootScope,
                            private $state: ng.ui.IStateService,
                            private refundClaimTypeService: interfaces.tariff.IRefundClaimTypeService,
                            public bsLoadingOverlayService,
                            private fileTemplateService: interfaces.master.IFileTemplateService,
                            private menuService: interfaces.applicationcore.IMenuService,                
                            private entityId: number
                        ) {
                            this.ownerEntityId = this.entityId
                            this.loadEntities();
                        }

                        getViewFileTemplateRight() {
                            this.viewFileTemplateRight = false;
                            return this.menuService.getGTSConnectMenuItem(703).get((result: interfaces.applicationcore.IMenu) => {
                                if (result.name) {
                                    this.viewFileTemplateRight = true;
                                }
                            }).$promise;
                        }


                        designTemplateClick_click(){
                            var url = '/#!/MasterData/FileTemplates';
                            window.open(url, '_blank');
                        }

                        loadEntities() {
                            return this.entityService.getList().query((successList) => {
                                this.entityList = successList;
                            }, (failureData) => {
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                            }).$promise;
                        }

                        ownerEntityChanged() {
      
                        }

                        downloadCreditLimitsToExcel() {                            
            
                            this.customsPartyService.getCreditLimitListExcel(this.ownerEntityId).then(() => {
                               
                            }, (data) => {
                         
                                this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>data.data);
                            });
                        }                 

                        cancel() {
                            this.$uibModalInstance.close(false);
                        }

                        upload() {
                            this.disableSubmit = true;
                            

                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'cominv.excelupload'
                            },
                                () => {

                                    const model = {
                                        entityId: this.ownerEntityId,
                                        ignoreInvalidCustomsParties: this.ignoreInvalidCustomsParties,
                                        overrideBalance: this.overrideBalance,
                                        repositoryFile: this.repositoryFile
                                    }

                                    return this.customsPartyService.uploadCreditLimitFromExcel().save(model, (result) => {
                                        this.generalService.displayMessageHandler(result);
                                        if (!result.HasErrorMessage) {
                                            this.$uibModalInstance.close(true);
                                        }

                                        this.$uibModalInstance.close(true);
                                    }, (errorResult) => {
                                        this.generalService.displayMessageHandler(errorResult.data);

                                        if (errorResult.data.Messages) {
                                            this.messages = [];
                                        }

                                        angular.forEach(errorResult.data.Messages, (o) => {
                                            angular.forEach(o.MessageItems, (n) => {
                                                this.messages.push(n);
                                            });
                                        });
                                        }).$promise;

                                });
                        }
                    },
                    controllerAs: "uploadCreditLimitExcelCtrl",
                    resolve: 
                    { 
                        entityId :  this.$rootScope.Entity.Id
                    }
                }).result.then((result) => {
                    if (result) {
                        this.loadCustomsPartys();
                    }
                });
            }



            loadStatuses() {
                return this.classificationValueService.GetClassificationValueDropdownByClassification().query({
                    classificationId: Enum.ClassificationEnum.CompanyStatus
                }, (resultList) => {
                    this.statusList = resultList;
                }).$promise;
            }


            loadEntities(searchText: string) {
                return this.entityService.getDropdownList(searchText).query(
                    () => {
                    }, (failureData) => {
                    }).$promise;
            }

            loadCountries() {
                return this.countryService.getDropdownList().query({
                },
                    (result: ng.resource.IResourceArray<interfaces.applicationcore.IDropdownModel>) => {
                    }, (failureData) => {
                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>failureData.data);
                    }).$promise;
            }


            getFilters() {
                _.forEach(this.filterNames, (name: string) => {
                    if (this.apiList.grid.getColumn(name).filters[0].term || this.apiList.grid.getColumn(name).filters[0].term == "") {
                        var keyValue: interfaces.applicationcore.IKeyValue = _.find(this.filterList, _.matchesProperty('key', name));

                        if (keyValue) {
                            var index = _.findIndex(this.filterList, (o) => { return o.key === name });

                            this.filterList[index] = <interfaces.applicationcore.IKeyValue>{
                                key: name,
                                value: this.apiList.grid.getColumn(name).filters[0].term
                            };
                        }
                        else {
                            this.filterList.push(<interfaces.applicationcore.IKeyValue>{
                                key: name,
                                value: this.apiList.grid.getColumn(name).filters[0].term
                            });
                        }
                    }
                });
            }

            setFilters() {
                if (this.filterList) {
                    _.forEach(this.filterList, (keyValue: interfaces.applicationcore.IKeyValue) => {
                        this.apiList.grid.getColumn(keyValue.key).filters[0].term = keyValue.value;
                    });
                }

                if (this.sortName && this.sortDirection) {
                    this.apiList.grid.getColumn(this.sortName).sort.direction = this.sortDirection;
                }
            }

            ListPageChange(newPage, pageSize) {
                this.paginationOptions.pageNumber = newPage;
                this.paginationOptions.pageSize = pageSize;

                this.DoSearch();
            }

            ListShortChange(gridApi) {
                this.DoSearch();
            }

            ListFilterChange(gridApi: uiGrid.IGridApi) {
                _.forEach(gridApi.grid.columns, (c) => {
                    if (!c.filters[0].term) {
                        var keyValue: interfaces.applicationcore.IKeyValue = _.find(this.filterList, _.matchesProperty('key', c.field));

                        if (keyValue) {
                            this.filterList.splice(this.filterList.indexOf(keyValue), 1);
                        }
                    }
                });

                this.DoSearch();
            }


            registerGridApi(gridApi: uiGrid.IGridApi) {
                this.apiList = gridApi;

                this.apiList.core.on.filterChanged(this.$scope, () => { this.ListFilterChange(gridApi) });
                this.apiList.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    this.ListShortChange(gridApi);

                    if (sortColumns[0]) {
                        this.sortName = sortColumns[0].name;
                        this.sortDirection = sortColumns[0].sort.direction;
                    }
                    else {
                        this.sortName = "";
                        this.sortDirection = "";
                    }
                });
                this.apiList.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => { this.ListPageChange(newPage, pageSize) });

                this.apiList.core.on.rowsRendered(this.$scope, () => {

                    for (let selectedRow of this.selectedRowsArray) {

                        for (var row of this.gvwList.data) {

                            if (selectedRow.Id === row.Id) {
                                this.apiList.selection.selectRow(row);
                            }
                        }
                    }
                });

                this.apiList.selection.on.rowSelectionChanged(this.$scope, (selected) => {
                    this.selected = selected;

                    if (!selected.isSelected) {

                        for (let selectedRow of this.selectedRowsArray) {
                            if (selectedRow.Id === selected.entity.Id) {
                                this.selectedRowsArray.splice(this.selectedRowsArray.indexOf(selectedRow), 1);
                            }
                        }
                    }
                    else {
                        var Exists: number = 0;
                        for (let selectedRow of this.selectedRowsArray) {
                            if (selectedRow.Id === selected.entity.Id) {
                                Exists = 1;
                            }
                        }

                        if (Exists === 0) {
                            this.selectedRowsArray.push(selected.entity);
                        }
                    }
                });

                this.$timeout(() => {
                    if (this.selected)
                        this.apiList.selection.selectRow(this.selected.entity);
                });
            }

            getBarColor(entity: interfaces.master.ICustomsPartyDisplay){
                if (entity.BalanceRemaining < 0) {
                    return '#cb2330'; //red
                } else if (entity.BalanceRemaining <= entity.CreditLimit * 0.20) {
                    return '#e66a00'; //amber
                } else {
                    return '#B8E50C'; //green
                }
            }

            getBarWidth(entity: interfaces.master.ICustomsPartyDisplay){
                if (entity.CreditLimit > 0) {
                    return Math.min(100, (entity.CurrentBalance / entity.CreditLimit) * 100);
                }
                return 0;
            }            


            gvwList: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: true,
                useExternalFiltering: true,
                enableCellEdit: false,
                useExternalSorting: true,
                multiSelect: false,
                enableColumnResizing: true,
                enableRowSelection: true,
                enableFullRowSelection: true,
                paginationPageSizes: [25, 50, 75, 100],
                paginationPageSize: 25,
                useExternalPagination: true,
                enableRowHeaderSelection: false,
                enableHorizontalScrollbar: 2,
                enableVerticalScrollbar: 1,
                onRegisterApi: (gridApi) => { this.registerGridApi(gridApi) 
                
                    this.apiList.cellNav.on.navigate(this.$scope, (newCol) => {
                        this.$timeout(() => {
                            this.apiList.selection.selectRow(newCol.row.entity);
                        });
                    });
                },
                columnDefs: [{
                    name: "ID",
                    displayName: "ID",
                    field: "Id",
                    visible: false,
                    enableFiltering: false
                }, {
                    name: "EDIT",
                    displayName: "",
                    enableFiltering: false,
                    cellTemplate: `
                            <div> 
                                <button type="button" ui-sref="auth.MasterData.CustomsParty.Update({ antId: row.entity.Id })" class="btn btn-default btn-sm">
                                    <span class="fa fa-pencil"></span>
                                </button>
                            </div>`,
                    enableSorting: false,
                    enableColumnMenu: false,
                    width: 35
                }, {
                    name: "EntityCode",
                    displayName: "Entity",
                    field: "EntityCode",
                    width: 80,
                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{grid.getCellValue(row, col)}}</div>',
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }, {
                    name: "CustomsCode",
                    displayName: "Customs Code",
                    field: "CustomsCode",
                    width: 150,
                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{grid.getCellValue(row, col)}}</div>',
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "CompanyCode",
                    displayName: "Code",
                    field: "CompanyCode",
                    width: 150,
                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{grid.getCellValue(row, col)}}</div>',
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "CompanyName",
                    displayName: "Company Name",
                    field: "CompanyName",
                    width: 320,
                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{grid.getCellValue(row, col)}}</div>',
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                }, {
                    name: "CountryCode",
                    displayName: "Country",
                    field: "CountryCode",
                    width: 100,
                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{grid.getCellValue(row, col)}}</div>',
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                },
                {
                    name: "ManageCreditLimit",
                    displayName: "Manage Credit Limit",
                    field: "ManageCreditLimit",                    
                    enableFiltering: false,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    cellTemplate: `<input type="checkbox" disabled   ng-model="row.entity.ManageCreditLimit">`,                                        
                    filter: {
                        condition: (searchTerm, cellValue, ) => {
                            if (searchTerm)
                                return cellValue === true;
                            else
                                return true;
                        }
                    } ,                         
                    width: 60
                },                                       
                {
                    name: "CreditLimit",
                    displayName: "Credit Limit",
                    field: "CreditLimit",
                    type: "number",
                    cellFilter: "number: 2",
                    cellClass: 'text-right',
                    width: 100,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="number" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/></div>
                            </div>`,
                    filter: {
                        condition: (searchTerm, cellValue) => {
                            return cellValue === searchTerm;
                        }
                    }
                },                       
                {
                    name: "CurrentBalanceAndCreditLimit",
                    displayName: "Current Balance",
                    field: "CurrentBalance",
                    width: 300, // Increased width to accommodate the progress bar
                    cellTemplate: `
                        <div class="ui-grid-cell-contents">
                            <div style="display: flex; align-items: center;"  ng-if="row.entity.ManageCreditLimit" >
                                <span>{{row.entity.CurrentBalance  | number: 2}}</span>
                                <div 
                                   
                                    class="balance-bar" 
                                    style="flex-grow: 1; margin: 0 5px; height: 20px; background-color: transparent; position: relative;">
                                    <div 
                                        style="background-color: {{grid.appScope.customsPartyListCtrl.getBarColor(row.entity)}};
                                               width: {{grid.appScope.customsPartyListCtrl.getBarWidth(row.entity)}}%;
                                               height: 100%;">
                                    </div>
                                </div>                                
                                <span>{{row.entity.BalanceRemaining  | number: 2}}</span>
                            </div>
                        </div>
                    `,
                    enableFiltering: false,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                },              
                {
                    name: "PercentageBalanceRemaining",
                    displayName: "% Remaining",
                    field: "PercentageBalanceRemaining",
                    type: "number",
                    cellFilter: "number: 2",
                    cellClass: 'text-right',
                    width: 100,
                    enableCellEdit: false,
                    enableCellEditOnFocus: false,
                    enableFiltering: false
                },                
                {
                    name: "CustomsCurrencyCode",
                    displayName: "Currency",
                    field: "CustomsCurrencyCode",
                    width: 100,
                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{grid.getCellValue(row, col)}}</div>',
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`,
                },                          
                {
                    name: "CompanyStatus",
                    displayName: "Status",
                    field: "CompanyStatus",
                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{grid.getCellValue(row, col)}}</div>',
                    width: 130,
                    filterHeaderTemplate: `
                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                <div class="input-group-sm">
                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                </div>
                            </div>`
                }

                ]
            };


        }

        angular.module("app").controller("customsPartyListCtrl", controllers.master.customsPartyListCtrl);
    }
}